// Feature cards interaction
document.addEventListener('DOMContentLoaded', function() {
  const featureCards = document.querySelectorAll('.feature-card');
  
  // Add hover effect with slight movement
  featureCards.forEach(card => {
    card.addEventListener('mousemove', function(e) {
      const rect = card.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      
      const centerX = rect.width / 2;
      const centerY = rect.height / 2;
      
      const moveX = (x - centerX) / 25;
      const moveY = (y - centerY) / 25;
      
      card.style.transform = `scale(1) perspective(1000px) rotateY(${moveX}deg) rotateX(${-moveY}deg)`;
      
      // Light effect
      const btnHighlight = card.querySelector('.feature-button');
      if (btnHighlight) {
        btnHighlight.style.background = `radial-gradient(circle at ${x}px ${y}px, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0.1) 40%, rgba(255,255,255,0) 60%)`;
      }
    });
    
    card.addEventListener('mouseleave', function() {
      card.style.transform = 'scale(0.98)';
      const btnHighlight = card.querySelector('.feature-button');
      if (btnHighlight) {
        btnHighlight.style.background = 'none';
      }
    });
  });
  
  // Announcement ticker responsive behavior
  const tickerTrack = document.querySelector('.ticker-track');
  if (tickerTrack) {
    // Calculate animation duration based on content length
    const tickerItems = document.querySelectorAll('.ticker-item');
    const totalWidth = Array.from(tickerItems).reduce((width, item) => {
      return width + item.offsetWidth + parseInt(getComputedStyle(item).marginRight);
    }, 0);
    
    // Adjust animation duration based on content length (faster for smaller screens)
    const duration = Math.max(20, totalWidth / 50);
    tickerTrack.style.animationDuration = `${duration}s`;
    
    // Pause animation on hover
    tickerTrack.addEventListener('mouseenter', () => {
      tickerTrack.style.animationPlayState = 'paused';
    });
    
    tickerTrack.addEventListener('mouseleave', () => {
      tickerTrack.style.animationPlayState = 'running';
    });
  }
});